<!-- Kompakter Modus: Nur Stil-Indikator -->
@if (compact) {
	<span class="color-indicator clickable grid-style-indicator"
		  [style.background-color]="getGridFillColor()"
		  [style.border-color]="getGridStrokeColor()"
		  (click)="openStyleModal()"
		  title="Punktstil ändern"></span>
} @else {
	<!-- Voller Modus (für LayerStore Accordion) -->
	@if (!gridEnabled) {
		<p class="text-muted mb-0">Klicken Sie auf <i class="bi bi-grid-3x3"></i> um das Punktraster zu aktivieren.</p>
	} @else {
		<div class="mb-3">
			<label class="form-label">Punktabstand (Hektar pro Punkt)</label>
			<div class="d-flex align-items-center gap-2">
				<input type="range" class="form-range flex-grow-1"
					   [min]="1" [max]="10" [step]="1"
					   [value]="gridResolution"
					   (input)="onResolutionChange($any($event.target).value)">
				<span class="badge bg-secondary">{{ gridResolution }} ha</span>
			</div>
		</div>
		<div class="d-flex align-items-center gap-2">
			<label class="form-label mb-0">Stil:</label>
			<span class="color-indicator clickable grid-style-indicator"
				  [style.background-color]="getGridFillColor()"
				  [style.border-color]="getGridStrokeColor()"
				  (click)="openStyleModal()"
				  title="Punktstil ändern"></span>
			<label class="form-label mb-0 ms-2">Größe:</label>
			<input type="range" class="form-range" style="width: 80px;"
				   [min]="1" [max]="10" [step]="1"
				   [value]="gridRadius"
				   (input)="onRadiusChange($any($event.target).value)">
			<span class="badge bg-secondary">{{ gridRadius }}px</span>
		</div>
	}
}
